/**
 * Filter Sentry error events. Modify events before sending it to Sentry OR return "nulll" to discard the error
 * @param event Sentry error event
 * @param hint Typically `hints` hold the original exception so that additional data can be extracted or grouping can be affected
 * @returns Event OR null to ignore error
 */
export function frontendBeforeSend(event, hint) {
  return event;
}

/**
 * Array of filter patterns. Can be a string (filters partial matches) or regex (exact match).
 * Shorthand if error message is available or not further modifications to the event is needed
 */
export const frontendIgnoreErrors = [
  /AbortError/i,
  /Cannot read properties of undefined/i,
  /Failed to fetch/i,
  /undefined is not an object/i,
  /SecurityError/i,
  /Usercentrics/i,
  /FIRST_LAYER/i,
  /this\._map is undefined/i,
];
